
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/google-floating-badge-generator",
      function () {
        return require("private-next-pages/tools/google-floating-badge-generator.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/google-floating-badge-generator"])
      });
    }
  